import React, { Component } from 'react';
import './iamExReTitleBar.css';

class IamExReTitleBar extends Component {

  state = {
    inputSort: 'UserAccessLevel'
  };

  componentDidMount() {

  };

  render() {

    const {users} = this.props;

    const accounts = users.reduce((acc, user) => {
      if (!acc.find(account => account.accountId === user.AccountId)) {
        acc.push({
          name: user.Account,
          accountId: user.AccountId
        });
      };
      return acc;
    }, []);

    accounts.sort((a, b) => {
      if ([a.name, b.name].sort()[0] === a.name) return -1;
      else return 1;
    });

    return (
      <div className="IamExReTitleBarPage">
        <h1>
                    IAM Report
        </h1>
        <div>
          <button onClick={this.props.refreshIamInformation}>{this.props.iamAuditUpdateInProgress ? 'Refreshing...' : 'Refresh IAM Information'}</button>
          <p>{`IAM information last updated ${this.props.updateDate}`}</p>
        </div>
        <div>
          <p>Account Filter</p>
          <select onChange={this.handleFilterChange} value={this.props.accountFilter}>
            <option value="All">All</option>
            {accounts.map(account => {
              return <option value={account.accountId} key={account.accountId}>{account.name}</option>;
            })}
          </select>
        </div>
        <div>
          <p>Sort</p>
          <select onChange={this.handleSortChange} value={this.state.inputSort}>
            <option value="UserAccessLevel">Access Level</option>
            <option value="Account">Account</option>
            <option value="LastAccess">Last Access</option>
            <option value="UserName">Username</option>
          </select>
          <button onClick={this.handleSubmitSort}>Sort</button>
        </div>
      </div>
    );
  };

    handleFilterChange = e => {
      this.props.updateFilter(e.target.value);
    }

    handleSortChange = e => {
      this.setState({inputSort: e.target.value});
    }

    handleSubmitSort = () => {
      this.props.updateUserSort(this.state.inputSort);
    }

};

export default IamExReTitleBar;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExReport/iamExReTitleBar/iamExReTitleBar.js